
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  emits: ["clicked"],
  methods: {
    play() {
      (this.$refs.textClickAudio as HTMLAudioElement).play();
      this.$emit("clicked");
    },
  },
});
